"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var ladda_config_1 = require("./ladda-config");
var Ladda = require("ladda");
var LaddaDirective = (function () {
    function LaddaDirective(el, config) {
        this.el = el.nativeElement;
        if (!config) {
            return;
        }
        // apply default styles if they aren't overwritten by an attribute
        for (var attribute in ladda_config_1.configAttributes) {
            var configValue = config[ladda_config_1.configAttributes[attribute]];
            if (!configValue) {
                continue; // don't waste time reading the attribute
            }
            if (!this.el.getAttribute(attribute)) {
                // attribute isn't set - apply the default config value
                var value = (typeof configValue === "number") ? configValue.toString() : configValue;
                this.el.setAttribute(attribute, value);
            }
        }
    }
    LaddaDirective.prototype.ngOnChanges = function (changes) {
        if (!this._ladda) {
            return; // needed since ngOnChanges is called before ngOnInit
        }
        if (changes['loading']) {
            this.updateLadda(changes['loading'].previousValue);
        }
        if (changes['disabled']) {
            this.updateDisabled();
        }
    };
    LaddaDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._ladda = Ladda.create(this.el);
        // if the initial loading value isn't false, a timeout of 0 ms
        // is necessary for the calculated spinner size to be correct.
        setTimeout(function () { _this.updateLadda(false); }, 0);
    };
    LaddaDirective.prototype.ngOnDestroy = function () {
        if (this._ladda) {
            this._ladda.remove();
        }
    };
    LaddaDirective.prototype.updateLadda = function (previousValue) {
        var loading = typeof this.loading === 'number' || !!this.loading;
        var wasLoading = typeof previousValue === 'number' || !!previousValue;
        if (!loading) {
            if (wasLoading) {
                this._ladda.stop();
            }
            return this.updateDisabled();
        }
        if (!wasLoading) {
            this._ladda.start();
        }
        if (typeof this.loading === 'number') {
            this._ladda.setProgress(this.loading);
        }
    };
    LaddaDirective.prototype.updateDisabled = function () {
        this.el.disabled = this.disabled;
    };
    return LaddaDirective;
}());
LaddaDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[ladda]'
            },] },
];
/** @nocollapse */
LaddaDirective.ctorParameters = function () { return [
    { type: core_1.ElementRef, },
    { type: ladda_config_1.LaddaConfigArgs, decorators: [{ type: core_1.Inject, args: [ladda_config_1.LaddaConfig,] }, { type: core_1.Optional },] },
]; };
LaddaDirective.propDecorators = {
    'loading': [{ type: core_1.Input, args: ['ladda',] },],
    'disabled': [{ type: core_1.Input, args: ['disabled',] },],
};
exports.LaddaDirective = LaddaDirective;
